import React, { useEffect, useRef, useState } from 'react'
import usePackagesActions from '../hooks/usePackagesActions'
import { usePackagesContext } from '../context/packages/PackagesProvider'
import { FaChevronDown } from 'react-icons/fa'
import useCountries from '../../core/hooks/useCountries'
import useRequestsActions from '../hooks/useRequestsActions'
import { toastError, toastSuccess } from '../../../config/global'
import { useNavigate, useParams } from 'react-router'
import { Helmet } from 'react-helmet'
import Spacing from '../../../componenets/UI/Spacing'
import SponsorPackage from '../components/SponsorPackage'
import { duration } from 'moment'
import Accordion from '../../core/components/Accordion'
import { Link } from 'react-router-dom'
import LoaderSponsorPackages from '../components/sponsor-packages-page/LoaderSponsorPackages'
import { useTranslation } from 'react-i18next'

export default function SponsorPackagesPage() {
  const { lng } = useParams()
  const { packagesState } = usePackagesContext()
  const { getPackages } = usePackagesActions()

  const [selectedPackage, setSelectedPackage] = useState(null)
  const { t } = useTranslation()
  const { countries } = useCountries()
  const [duration, setDuration] = useState('YEAR')
  const nameRef = useRef(null)
  const entityRef = useRef(null)
  const emailRef = useRef(null)
  const phoneRef = useRef(null)
  const [selectedCountry, setSelectedCountry] = useState('')
  const { createSponsorRequest } = useRequestsActions()
  const navigate = useNavigate()

  const handelOnSubmitRequest = async () => {
    try {
      const fullName = nameRef.current.value
      const concernedParty = entityRef.current.value
      const email = emailRef.current.value
      const phone = phoneRef.current.value
      const countryId = selectedCountry

      const payload = {
        sponsor_package_id: selectedPackage.id,
        full_name: fullName,
        concerned_party: concernedParty,
        country_id: countryId,
        email: email,
        phone: phone,
        duration: duration,
      }

      const message = await createSponsorRequest(payload)

      navigate(`/${lng}/home`)
    } catch (error) {
      console.log(error)
      toastError(error.response.data.error)
    }
  }

  useEffect(() => {
    getPackages()
  }, [])

  return (
    <div>
      <Helmet>
        <title>{`APFM | باقات الرعاية`}</title>
      </Helmet>
      <Spacing />
      <div className="app-container px-8 lg:px-0">
        <div
          data-aos={`fade-up`}
          data-aos-delay={100}
          className="mb-4 lg:h-[321px] w-full overflow-hidden"
        >
          <img
            src={t('YOUR_SPONSORSHIP')}
            alt="Sponsor Package"
            className="h-full w-full object-contain object-center"
          />
        </div>
        <p
          className="mb-2"
          data-aos={`fade-up`}
          data-aos-delay={100}
        >
          {t('sponsorship_message')}
        </p>
        <div
          data-aos={`fade-down`}
          className="mb-4 bg-danger-500 p-4 text-center text-2xl font-bold text-white"
        >
          {t('discount_offer')}
        </div>
        <h2
          data-aos={`fade-down`}
          data-aos-delay={100}
          className="mb-4 text-2xl font-black"
        >
          {t('sponsorship_packages')}
        </h2>

        {packagesState.isLoading && <LoaderSponsorPackages />}
        <div className="mb-8 grid grid-cols-12 gap-2">
          {packagesState?.packages?.map((pkg) => (
            <SponsorPackage
              key={pkg.id}
              pkg={pkg}
              duration={duration}
              setDuration={setDuration}
              onSubmit={handelOnSubmitRequest}
            />
          ))}
        </div>
        <div
          data-aos={`fade-down`}
          className="mb-8 flex flex-col gap-2"
        >
          <Accordion title={t('sponsorship_steps')}>
            <ul className="flex list-disc flex-col gap-2 p-4 px-16">
              <li>{t('registration_info')}</li>
              <li>{t('sponsorship_approval_info')}</li>
            </ul>
          </Accordion>
          <Accordion title={t('payment_method')}>
            <ul className="flex flex-col gap-2 p-4 px-8">
              <li>{t('payment_instructions')}</li>
              <li>
                <ul className="list-disc px-8">
                  <li>{t('bank_details.bank_name')}</li>
                  <li>{t('bank_details.account_number')}</li>
                  <li>{t('bank_details.swift_code')}</li>
                </ul>
              </li>
              <li>{t('activation_note')}</li>{' '}
            </ul>
          </Accordion>
        </div>
        <div data-aos={`fade-down`}>
          <img
            src="/assets/sponsor-guide.jpg"
            className="h-32 border-2"
            alt="sponsor guide"
          />
          <Link
            to={`https://drive.google.com/file/d/1L-VYVr4AeRgcmaybIAdJHktymSvSnXdm/view`}
            target="_blank"
          >
            {t('download_sponsorship_guide')}
          </Link>
        </div>
      </div>
    </div>
  )
}
